function Footer({ currentYear }) {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div>
          <h4>Aksh Yadav</h4>
          <p>
            This is a personal space for technical writing, project reflections, and lessons
            from building projects with intent.
          </p>
          <span className="footer-illustration" aria-hidden="true">
            <svg viewBox="0 0 110 24" role="img">
              <rect x="1" y="6" width="108" height="12" rx="6" fill="#ffffff24" />
              <circle cx="16" cy="12" r="4" fill="#5caedc" />
              <circle cx="30" cy="12" r="4" fill="#7abfe5" />
              <circle cx="44" cy="12" r="4" fill="#9fd0ee" />
            </svg>
          </span>
        </div>
        <div>
          <h5>Explore</h5>
          <p>Blogs, full post pages, various categories, and search-based navigation support.</p>
        </div>
        <div>
          <h5>Contact</h5>
          <p>Email: akshy9083@gmail.com</p>
          <p>Yotube: @Krakexn</p>
          <p>Instagram: _ksh.ydv</p>
        </div>
      </div>
      <p className="footer-note">© {currentYear} Aksh Yadav. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
